/*
 * Copyright (C) 2014 Spanning Cloud Apps.  All rights reserved.
 */
/**
 * Service module for common wizard services/utilities.
 */
'use strict';

angular
  .module('services.wizard', [])
  /**
   * A factory with common wizard utilities.
   *
   * The wizard service is used by the purchase wizard. It
   * allows the purchase panels to override next and previous methods to
   * add additional logic when navigating between the panels. The nextParent/previousParent
   * methods hold the controls that shift to the next/previous page in the ui. The next and previous
   * methods hold any page specific logic that needs to be evaluated before the parent methods are
   * executed.
   */
  .factory('wizardUtils', function () {
    return {
      // property for tracking the disabled state of the next button.
      nextBtnDisabled: false,

      // property for tracking the disabled state of the prev button.
      previousBtnDisabled: false,

      /**
       * Stub for next disabled method.
       */
      nextDisabled: function () {},

      /**
       * Stub for prev disabled method.
       */
      previousDisabled: function () {},

      /**
       * Stub for next parent method.
       */
      nextParent: function () {},

      /**
       * Stub for previous parent method.
       */
      previousParent: function () {},

      /**
       * Stub for next method.
       */
      next: function () {
        this.nextParent();
      },

      /**
       * Stub for previous method.
       */
      previous: function () {
        this.previousParent();
      }
    };
  });
